import React, { Component, Fragment } from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, NavItem, NavLink, UncontrolledDropdown} from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import GeneralModal from "../General/Modal";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class LoginMenu extends Component {
    constructor(props) {
        super(props);

        const cookieValue = cookies.get('eurostarcookievalues');
        let userPhone = "";
        let cityCode = "";
        let currentCity = "";

        if (cookieValue != null && cookieValue != undefined) {
            userPhone = cookieValue.userPhone;
            cityCode = cookieValue.cityCode;
            currentCity = cookieValue.cinemaName;
        } else {
            userPhone = "";
            cityCode = 11;
            currentCity = "Falkenberg";
        }

        this.updateActiveCity = this.updateActiveCity.bind(this);
        this.updateActivePhoneNumber = this.updateActivePhoneNumber.bind(this);
        this.renderCityDropDown = this.renderCityDropDown.bind(this);
        this.updateMemberCity = this.updateMemberCity.bind(this);
        this.state = {
            isAuthenticated: false,
            userName: null,
            cities: [],
            loadingCities: true,
            userPhone: userPhone,
            cityCode: cityCode,
            currentCity: currentCity
        };
    }
    
    async checkMemberCity() {

        const token = await authService.getAccessToken()
        //console.log("Active user here:" + token);
        if (token) {
            this.populateMemberCity();
        }
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
        this.populateCityList();
        this.checkMemberCity();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    renderCityDropDown(cities) {
        return (
            <DropdownMenu right>
                {cities.map(city =>
                    <DropdownItem key={city.code} value={city.phone} onClick={() => this.updateActiveCity(city)}>{city.name}</DropdownItem>
                )}
            </DropdownMenu>
        );
    }

    async populateMemberCity() {
        const token = await authService.getAccessToken();
        let data = null;
        if (token) {
            const response = await fetch('api/member/getmembercity', {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            }).then(
                async function (response) {
                if (response.status === 401) {
                    await authService.signOut();
                    return false;
                } else {
                    data = await response.json();
                    //console.log(data);
                }
            }).catch(function (error) {
                console.log('Fel uppstod: ' + error)
            });            

            if (data) {
                //console.log(data);
                if ((Number(data.city) !== Number(this.state.cityCode))&&data.city!==undefined) {
                    this.setState({ cityCode: data.city });
                    this.setState({ userPhone: data.phoneNo });
                    //console.log("Setting the city now" + data);
                    //console.log(data);
                    let tmpItem;
                    // eslint-disable-next-line array-callback-return
                    this.state.cities.map((cityItem) => {
                        if (Number(cityItem.code) === Number(data.city)) {
                            tmpItem = cityItem;
                        }
                    });

                    this.updateActivePhoneNumber(tmpItem, data.phoneNo);
                    //this.updateActiveCity(tmpItem);
                    //console.log("booo" + tmpItem);
                }
            }
        }
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({
            isAuthenticated,
            userName: user && user.name
        });
    }

    async populateCityList() {
        const response = await fetch('/api/home/getcities');
        const data = await response.json();
        this.setState({ cities: data, loadingCities: false });
    }

    updateActiveCity(cityEntry) {
        if (cityEntry) {

            //console.log("Hello dude: " + cityEntry);

            let cookieValues = {
                cityCode: cityEntry.code,
                cinemaPhone: cityEntry.phone,
                cinemaName: cityEntry.name,
                userPhone: this.state.userPhone === undefined ? this.state.userPhone : ""
            }

            //console.log("before citychange");
            //console.log(cityEntry);
            //console.log(cookieValues);
            //console.log("after citychange");

            this.setState({ currentCity: cityEntry.name });
            this.updateMemberCity(cityEntry.name, cityEntry.code);
            cookies.set('eurostarcookievalues', cookieValues, { path: '/', maxAge: 1000000 });
            window.location.href = "/";
        }
    }

    updateActivePhoneNumber(cityEntry, phoneNumber) {
        if (cityEntry === undefined || cityEntry === "") {
            return false;
        }

        if (phoneNumber === undefined || phoneNumber === "") {
            return false;
        }

        /*if (phoneNumber) {*/
            //console.log("Hello phone number: " + phoneNumber);
            let cookieValues = {
                cityCode: cityEntry.code,
                cinemaPhone: cityEntry.phone,
                cinemaName: cityEntry.name,
                userPhone: phoneNumber === undefined ? phoneNumber : ""
            }

            console.log("before phonechange");
            //console.log(phoneNumber);
            console.log(cookieValues);
            //console.log("after phonechange");

            this.setState({ userPhone: phoneNumber });
            cookies.set('eurostarcookievalues', cookieValues, { path: '/', maxAge: 1000000 });
        //}
    }

    async updateMemberCity(cityName, cityValue) {
        //console.log("Hello dude again: " + cityValue);
        const token = await authService.getAccessToken();
        if (token) {
            //console.log("Token something: " + token);
            const response = await fetch('api/member/updateMemberCity?cityCode=' + cityValue + '&cityName=' + cityName, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });
            await response.json();
        }        
    }

    render() {
        let cityDropDownContents = this.state.loadingCities
            ? <span></span>
            : this.renderCityDropDown(this.state.cities);
        let cityDropDownTitle = this.state.currentCity
            ? this.state.currentCity
            : "Välj Stad";

        const { isAuthenticated, userName } = this.state;
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.Register}`;
            const loginPath = `${ApplicationPaths.Login}`;
            return this.anonymousView(registerPath, loginPath, cityDropDownTitle, cityDropDownContents);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            const logoutPath = `${ApplicationPaths.LogOut}`;
            return this.authenticatedView(userName, profilePath, logoutPath, cityDropDownTitle, cityDropDownContents);
        }
    }

    authenticatedView(userName, profilePath, logoutPath, cityDropDownTitle, cityDropDownContents) {
        return (<Fragment>
            <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>{cityDropDownTitle}</DropdownToggle>
                {cityDropDownContents}
            </UncontrolledDropdown>
            <NavItem>
                <NavLink tag={Link} className="text-dark" to="/Medlem">Inloggad {this.state.userPhone}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={Link} className="text-dark" to="/Medlem">Mina sidor</NavLink>
            </NavItem>
            <NavItem>
                <NavLink tag={Link} className="text-dark" to={logoutPath}>Logga ut</NavLink>
            </NavItem>
        </Fragment>);
    }

    anonymousView(registerPath, loginPath, cityDropDownTitle, cityDropDownContents) {
        return (<Fragment>
            <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>{cityDropDownTitle}</DropdownToggle>
                {cityDropDownContents}
            </UncontrolledDropdown>
            <NavItem>
                <NavLink className="specialMenuItem" tag={Link} className="text-dark" to={registerPath}>Bli medlem</NavLink>
            </NavItem>
            <NavItem>
                <GeneralModal isModalOpen={this.state.isModalOpen} modalHeader={this.state.modalHeader} modalType={this.state.modalType} modalContents={this.state.modalContents} UpdateValue={this.handleUpdateValue} handler = {this.handler} />
                <NavLink tag={Link} className="text-dark" to={loginPath}>Logga in</NavLink>
            </NavItem>
        </Fragment>);
    }
}
